import React, { createContext, useRef, useState, useEffect } from 'react';

export const NavbarHeightContext = createContext();

export const NavbarHeightProvider = ({ children }) => {
    const navbarRef = useRef(null);
    const [navbarHeight, setNavbarHeight] = useState(0);

    useEffect(() => {
        const updateNavbarHeight = () => {
            setNavbarHeight(navbarRef.current.offsetHeight);
        };
        window.addEventListener('resize', updateNavbarHeight);
        updateNavbarHeight(); // Initial update

        return () => {
            window.removeEventListener('resize', updateNavbarHeight);
        };
    }, []);

    return (
        <NavbarHeightContext.Provider value={{ navbarRef, navbarHeight }}>
            {children}
        </NavbarHeightContext.Provider>
    );
};
